export default __webpack_public_path__ + "static/slack-with-back-9f31905385dd1bab4c5be6a6e67a4f00.svg";